module.exports = __webpack_public_path__ + "img/leadingTwo.e93663e3.png";